// extracted by mini-css-extract-plugin
export default {"cardTitle":"Home_cardTitle__WFgpr","homeGrid":"Home_homeGrid__VPV85","homeRow":"Home_homeRow__pG-hf","homeCol":"Home_homeCol__+yjaN"};